import { StyledIcon } from "./StyledIcon";

// Inline the SVG as JSX
const Icon = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 44 44">
    <path fill="#D91848" d="M24 32c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2zm-.5-6V10h-3v16h3z" />
    <path
      fill="#D91848"
      fillRule="evenodd"
      d="M22 44c12.1503 0 22-9.8497 22-22C44 9.84974 34.1503 0 22 0 9.84974 0 0 9.84974 0 22c0 12.1503 9.84974 22 22 22zm0-3c10.4934 0 19-8.5066 19-19S32.4934 3 22 3 3 11.5066 3 22s8.5066 19 19 19z"
      clipRule="evenodd"
    />
  </svg>
);

// Style the inline SVG
const ErrorStyling = StyledIcon(Icon);

export const ErrorIcon = () => <ErrorStyling />;
